import { MiscService } from '@app/core/services/misc.service';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';
import { AlertController } from '@ionic/angular';
import { LanguageService } from '@app/core/services/language.service';
import { DynamicIconComponent } from '@app/shared/components/dynamic-icon';
import { JsonPipe } from '@angular/common';

@Component({
  selector: 'app-formly-field-wrapper',
  templateUrl: './formly-field-wrapper.component.html',
  styleUrls: ['./formly-field-wrapper.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FormlyModule,
    TranslateModule,
    DynamicIconComponent,
  ],
})
export class FormlyFieldWrapperComponent  extends FieldWrapper {

  constructor(public languageService: LanguageService,
              private miscService: MiscService,
              private alertCtrl: AlertController) { 
    super();
  }

  public getColumnSpacer = (props: any): string => {
    return props.label ? this.languageService.getColumnSpacer() : '';
  }

  public showHelpText = async (props: any) => {
    if (!props.helpText) {
      return;
    }
    const alert = await this.alertCtrl.create({
      header: this.languageService.instant(props.label),
      subHeader: this.languageService.instant(props.helpText),
      buttons: [{ text: this.languageService.instant('Ok') }]
    });
    await alert.present();
  };

  public getErrorMessages = (): string[] => {
    let errorMessages = [];
    if (this.formControl && this.formControl.errors) {
      const keys = Object.keys(this.formControl.errors);
      if (keys.length > 0) {
        for (const key of keys) {
          const errType = this.formControl.errors[key];
          let errText= this.languageService.instant('ERRORS.' + key.toUpperCase());
          if (errType) {
            for (const attr in errType) {
              errText = errText.replace('{{' + attr + '}}', errType[attr]);
            }
            errorMessages.push(errText)
          }
        }
      }
    }
    return errorMessages;
  };


  public isDefined(): boolean {
    const model = this.field?.props?.['context']?.['model'];
    if (!model)  return false;
    const value = this.miscService.getDeepChildValue(model, (this.field.key as string || this.field.props?.['key']) as string);
    if (!value) { // check if we are in a fieldArray. In this case, the parentKey should point to an array in model
      const parentValue = this.miscService.getDeepChildValue(model, (this.field.props?.['parentKey'] as string) || '');
      if (parentValue && typeof parentValue === 'object' && Array.isArray(parentValue)) {
        return true;
      }
    }

    if (value === null || value === undefined)  return false;
    if (typeof value === 'object' && Array.isArray(value) && value.length === 0)  return false;
    if (typeof value === 'string' && value.trim() === '')  return false;
    return true;
  }

  public showHeaders(props:any): boolean {
    return props.hideHeaders !== true;
  }
}
